module.exports = __webpack_public_path__ + "img/travamentos.ce68006e.png";